export default {
    name: 'pp-list-value',
    props: {
        render: Object,
    },
    render: function() {
        return this.render;
    },
}